/**
 * Presentation Layer - ResetButton Component
 * リセットボタンコンポーネント
 */

import React from 'react';
import { Button } from '@mui/material';

/**
 * Props定義
 */
export interface ResetButtonProps {
  /** クリック時のコールバック */
  onClick: () => void;
  /** 無効化フラグ */
  isDisabled?: boolean;
  /** ボタンラベル */
  label?: string;
}

/**
 * リセットボタンコンポーネント
 */
export const ResetButton: React.FC<ResetButtonProps> = ({
  onClick,
  isDisabled = false,
  label = 'リセット',
}) => {
  return (
    <Button
      variant="outlined"
      onClick={onClick}
      disabled={isDisabled}
    >
      {label}
    </Button>
  );
};
